var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightMoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.9035 12.0048C16.0921 12.343 15.2215 12.5165 14.3424 12.5153C12.5773 12.5153 10.8845 11.8142 9.63642 10.566C8.38831 9.31794 7.68713 7.62514 7.68713 5.86004C7.68713 4.95219 7.8687 4.08735 8.19771 3.29895C6.98506 3.80483 5.94923 4.65824 5.22067 5.75169C4.49211 6.84514 4.1034 8.12973 4.10352 9.44366C4.10352 11.2088 4.8047 12.9016 6.0528 14.1497C7.30091 15.3978 8.99371 16.099 10.7588 16.099C12.0727 16.0991 13.3573 15.7104 14.4508 14.9818C15.5442 14.2532 16.3976 13.2174 16.9035 12.0048Z",
    stroke: "white",
    strokeWidth: 1.02389,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMoon);
export default __webpack_public_path__ + "static/media/lightMoon.61ad005a1086f11ba517ca31ef040eba.svg";
export { ForwardRef as ReactComponent };